/* global VERSION, APP_ENV */

import 'babel-polyfill';
import './ui/css/app.css';
import './assets/favicon-old.ico';

import SessionController from './controllers/Session';
import controllers from './controllers';
import logger from './utils/Logger';

// do not send exec timeout to rollbar
global.window.clearTimeout(global.window.jsExecTimeout);

// handle uncaught errors right away
global.window.addEventListener('error', e => {
  logger.critical(e.error || e, { state: global.session.state });
});

logger.info(`Running client ${VERSION} in ${APP_ENV} mode.`);

global.session = new SessionController(global.document.getElementById('mount-point'), controllers);



// WEBPACK FOOTER //
// ./src/main.js